import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type AccountIrregularUseProps = RowProps;

export const AccountIrregularUse = forwardRef<AccountIrregularUseProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.account_irregular_use.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.account_irregular_use.value',
        },
        {
          fixed: toFixed(fees.accountIrregularUse),
          variable: toVariable(fees.accountIrregularUse),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
